export enum DeploymentStatus {
	Deployed = 'Deployed',
	InDevelopment = 'In Development'
}
